import { Notification as customNotification } from '../../../components/ui/custom-notification';
import get from 'lodash/get';
import {
  put,
  takeLatest,
} from 'redux-saga/effects';
import axiosConfig from '../axiosConfig';
import { 
  GET_ALL_PIPE_DETAILS, 
  GET_ALL_PIPE_DETAILS_SUCCESS, 
  GET_ALL_PIPE_DETAILS_FAILURE,
  GET_LIST_MANUFACTURING_CATEGORY,
  GET_LIST_MANUFACTURING_CATEGORY_SUCCESS,
  GET_LIST_MANUFACTURING_CATEGORY_FAILURE
} from './types';
import { 
  getAllPipeDetailsSuccess, 
  getAllPipeDetailsFailure,
  getListManufacturingCategorySuccess,
  getListManufacturingCategoryFailure
} from './action';

function* getAllPipeDetails({ projectId }) {
  try {
    const url = `/pipeDetails/getAllPipeDetails?project_id=${projectId}`;
    const res = yield axiosConfig.get(url);
    
    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      yield put(getAllPipeDetailsFailure());
      return;
    }
    
    if (res.status === 200) {
      const responseData = get(res, ['data', 'data'], {});
      yield put(getAllPipeDetailsSuccess({ responseData }));
    } else {
      yield put(getAllPipeDetailsFailure());
      customNotification.error('Something went wrong.', 'Failed to fetch pipe details.');
    }
  } catch (error) {
    yield put(getAllPipeDetailsFailure());
    customNotification.destroy();
    customNotification.error('Failed to fetch pipe details', error.message || error.error);
  }
}

function* getListManufacturingCategorySaga() {
  try {
    const url = `/manufacturer/getAllManufacturers`;
    const res = yield axiosConfig.get(url);
    
    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      yield put(getListManufacturingCategoryFailure());
      return;
    }
    
    if (res.status === 200) {
      const responseData = get(res, ['data', 'data', 'data'], []);
      yield put(getListManufacturingCategorySuccess({ responseData }));
    } else {
      yield put(getListManufacturingCategoryFailure());
      customNotification.error('Something went wrong.', 'Failed to fetch manufacturing categories.');
    }
  } catch (error) {
    yield put(getListManufacturingCategoryFailure());
    customNotification.destroy();
    customNotification.error('Failed to fetch manufacturing categories', error.message || error.error);
  }
}

function* setupDataWatcher() {
  yield takeLatest(GET_ALL_PIPE_DETAILS, getAllPipeDetails);
  yield takeLatest(GET_LIST_MANUFACTURING_CATEGORY, getListManufacturingCategorySaga);
}

export default function* setupDataSaga() {
  yield setupDataWatcher();
}

